import { render } from "./LicenseBanner.vue?vue&type=template&id=b12c1c3e&scoped=true"
import script from "./LicenseBanner.vue?vue&type=script&lang=js"
export * from "./LicenseBanner.vue?vue&type=script&lang=js"

import "./LicenseBanner.vue?vue&type=style&index=0&id=b12c1c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b12c1c3e"]])

export default __exports__